export default function() {
  return (
    <img src={require('../../assets/images/image-3.jpg')} />
  );
}